import React, { Component } from 'react'
import { formatDateStandard } from '../../../../global/formatters/string-formatter.js'
import RiskReturnChart from '../../Helpers/RiskReturnChart.js'

class RatingsRiskRiskReturn extends Component {
  constructor(props) {
    super(props)

    this.init()
  }

  init() {
    this.riskReturnChart = new RiskReturnChart(
      this.props.threeYrAvgAnnRetStdDev
    )
  }

  componentDidMount() {
    this.riskReturnChart.renderScatterPlotChart(
      'three-year-standard-deviation-chart'
    )
  }

  render() {
    const { risk } = this.props

    return (
      <div
        className="Content"
        data-section-content="ratings-risk"
        id="ratings-risk"
      >
        <div className="Grid Grid--alignMiddle u-marginBottom3gu">
          <div className="Content u-sizeFill">
            <h3 className="u-margin0">
              Risk vs Return
              <span> as of {formatDateStandard(risk?.riskEffectiveDate)} </span>
            </h3>
          </div>
        </div>
        <div
          id="three-year-standard-deviation-chart"
          className="Grid Grid--alignBottom Grid--withGutter"
        ></div>
      </div>
    )
  }
}

export default RatingsRiskRiskReturn
